import i18n from '@/plugins/i18n'
import Model from './BaseModel'
import PlanModule from './PlanModule'

export default class Plan extends Model {
    resourceName() {
        return 'plans'
    }

    fields() {
        return [
            'id',
            'external_key',
            'consultant_id',
            'consultant',
            'customer_id',
            'name',
            'type',
            'value',
            'over_value',
            'final_price',
            'due_day',
            'activated_at',
            'created_at',
            'updated_at',
            'canceled_at',
            'changed_at',
            'deleted_at',
        ]
    }

    relationships() {
        return {
            planModules: new PlanModule(),
        }
    }

    dates() {
        return {
            activated_at: 'YYYY-MM-DD',
            created_at: 'YYYY-MM-DD',
            updated_at: 'YYYY-MM-DD',
            canceled_at: 'YYYY-MM-DD',
            changed_at: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedActivatedAt(plan) {
                return plan.activated_at.isValid()
                    ? i18n.d(plan.activated_at, 'datetimewtsec')
                    : null
            },

            formattedCreatedAt(plan) {
                return plan.created_at.isValid()
                    ? i18n.d(plan.created_at, 'datetimewtsec')
                    : null
            },

            formattedUpdatedAt(plan) {
                return plan.updated_at.isValid()
                    ? i18n.d(plan.updated_at, 'datetime')
                    : null
            },

            formattedCanceledAt(plan) {
                return plan.canceled_at.isValid()
                    ? i18n.d(plan.canceled_at, 'datetime')
                    : null
            },

            formattedChangedAt(plan) {
                return plan.changed_at.isValid()
                    ? i18n.d(plan.changed_at, 'datetime')
                    : null
            },

            formattedDeletedAt(plan) {
                return plan.deleted_at.isValid()
                    ? i18n.d(plan.deleted_at, 'datetime')
                    : null
            },

            status(plan) {
                return plan.deleted_at.isValid() ? 'Inativo' : 'Ativo'
            },
        }
    }
}
